import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AboutUs from './Components/AboutUs/AboutUs';
import HomePage from './Components/Home/home';
import Portfolio from './Components/Portfolio/Portfolio';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import ProductPage from './Components/ProductPage/ProductPage';
import ExportPage from './Components/ExportPage/ExportPage';
import ImportPage from './Components/ImportPage/ImportPage';
import BPO from './Components/Home/BPO/BPO';
import DubaiBusinessConsulting from './Components/Home/BPO/DubaiBusinessConsulting ';
import Training from './Components/Home/BPO/Training';
import ThirdPartyInspection from './Components/Home/BPO/ThirdPartyInspection';
import Contactus from './Components/ContactUs/ContactUs';
import PrivacyPolicy from './Components/PrivacyPolicy/PrivacyPolicy';
import AlliedBusinesses from './Components/AlliedBusinesses/AlliedBusinesses';
import Reels from './Components/Portfolio/Portfolio';


function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/export" element={<ExportPage />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/reels" element={<Reels />} />
          <Route path="/contact" element={<Contactus />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          
          <Route path="/AlliedBusinesses" element={<AlliedBusinesses />} />
            {/* <Route path="/bpo" element={<BPO />} /> */}

        <Route path="/dubai-business-consulting" element={<DubaiBusinessConsulting />} />
        <Route path="/training" element={<Training />} />
        <Route path="/third-party-inspection" element={<ThirdPartyInspection />} />
        </Routes>
        <Footer/>
      </div>
    </Router>
  );
}

export default App;